import { Type, setCookies as baseSetCookies, destroy, read } from '@acorns/web-utils'

import { AUTH_TOKEN, USER_EMAIL, USER_UUID } from 'app-constants'

export const closeSession = () => {
  destroy(Type.token)
  destroy(Type.partition)
  window.sessionStorage.removeItem(USER_UUID)
}

export const hasToken = () => Boolean(read(Type.token))

export const setCookies = (authSession, userEmail?: string) => {
  baseSetCookies(authSession)
  window.sessionStorage.setItem(USER_UUID, authSession.identityId)
  window.sessionStorage.setItem(AUTH_TOKEN, authSession.token)

  if (userEmail) {
    window.sessionStorage.setItem(USER_EMAIL, userEmail)
  }
}
